import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { smlRoutePath } from '../../../../../routing/sml/smlRoutePath';
import { useConnectReturn } from '../../hooks/useConnectReturn';

/**
 * The return of a channel sign-in that started in "Send to all" (`sendAllReturnTo`): the server
 * sends the artist back to the open sheet with `promoConnect=&result=`. The hook reads the sheet
 * again and removes the outcome from the URL (`useConnectReturn`). A login that reached several
 * Pages (`pickTarget`) goes on to Promote → Channels, where the artist picks one. Answers true
 * when the sign-in failed.
 */
export function useSendAllConnectReturn(onReturn: () => void): boolean {
  const { outcome } = useConnectReturn({ onReturn });
  const navigate = useNavigate();

  useEffect(() => {
    if (outcome?.result === 'pickTarget') {
      const query = new URLSearchParams({ promoConnect: outcome.platform, result: 'pickTarget' });
      // eslint-disable-next-line no-void
      void navigate(`/${smlRoutePath(SMLRoutes.promoteChannels)}?${query.toString()}`);
    }
  }, [navigate, outcome]);

  return outcome?.result === 'error';
}
